import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { HeroSection } from "../components/herosection";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { FeatureGrid } from "../components/FeatureGrid";

interface Section {
  type: string;
  id?: string;
  variant?: string; // new variant prop
  [key: string]: any;
}

interface SectionsData {
  sections: Section[];
}

export const Services: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);

  useEffect(() => {
    loadYaml("/config/services.yaml").then((data: SectionsData) => {
      setSections(data.sections);
    });
  }, []);

  return (
    <div>
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            return (
              <HeroSection
                key={idx}
                carousel={s.carousel || []}
                id={s.id}
                variant={s.variant}
              />
            );

          case "bifurcatedPromo":
            return (
              <BifurcatedPromo
                key={idx}
                title={s.title || ""}
                left={s.left || { title: "", description: "" }}
                right={s.right || { title: "", description: "" }}
                id={s.id}
               
              />
            );

          case "featureGrid":
            return (
              <FeatureGrid
                key={idx}
                title={s.title || ""}
                features={s.features || []}
                id={s.id}
                variant={s.variant}
              />
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default Services;
